import TeacherLayout from "./TeacherLayout";
import { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import CustomizedSnackbars from "../../Feedback";
import { IoIosAddCircle } from "react-icons/io";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { addClassAction } from "../../../Firebase/actions/addClassAction";

const AddClass = ({ addClassAction, addClassSuccess, addClassError,  admins, auth, resetSuccess }) => {

    const [ programmeCode, setProgrammeCode ] = useState('');
    const [ classLink, setClassLink ] = useState('');
    const [ classCode, setClassCode ] = useState('');
    const [ moduleName, setModuleName ] = useState('');
    const [ error, setError ] = useState(null);

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    // simualting student object from db
    let teacher;
    if(auth.uid) {
        let admin;
        
        if (admins) {
            
            admin = admins.filter((item) => {
                return item.id === auth.uid
            });  
            
            teacher = admin[0];     //console.log(output, auth);
            
        }     
    }
    // ======
    
    
    const handleSubmit = (e) => {
        e.preventDefault();

        if(programmeCode !== '' || classLink !== '' || classCode !== '' || moduleName !== '') {
            // to db
            setError(null);
            const teacherName = `${teacher.forenames[0]}. ${teacher.surname}`;
            let data = {
                moduleName,
                programmeCode,
                classLink,
                classCode,
                teacher:  teacherName,
                teacherId: teacher.id
            }
            addClassAction(data);
            document.getElementById('Btn').classList.add('is-loading');

        } else {
            setError(true);
        }
        //onsole.log('rub')
    }

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });

        if(addClassSuccess) {
            document.getElementById('Btn').classList.remove('is-loading');
            //reset form
            setClassCode('');
            setClassLink('');
            setModuleName('');
            
            //on success
            setFeedbackText('Class added successfully.');
            setSeverity('success');
            setOpenFeedback(true);
            
            resetSuccess();
        }

        if(addClassError) {
            document.getElementById('Btn').classList.remove('is-loading');
            //on error
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
        }

    }, [addClassSuccess, addClassError, resetSuccess]);

    return ( 
        <TeacherLayout>
            <div className="pt-5">
                <div className="container">
                    <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">Add Classroom:</h5>
                    <div className="divider mb-5"></div>
                    <p className="block is-size-5 grey-text text-darken-2">Select a classroom you wish to add a google classrooom and enter the google classroom invite link and the code.</p>
                    <form className="row mt-5" onSubmit={handleSubmit}>
                      
                        <div className="input-field col s12 m4 l4">
                            <select onChange={(e) => setProgrammeCode(e.target.value)} value={programmeCode}>
                                <option value="" disabled>Select</option>
                                    <option value="CV082021 NC1">CV082021 NC1</option>
                                    <option value="CV082021 NC2">CV082021 NC2</option>
                                    <option value="CV012022 NC3">CV012022 NC3</option>
                                    <option value="CV012022 NC4">CV012022 NC4</option>
                                    <option value="CV012022 NC5">CV012022 NC5</option>
                                    <option value="QS082021 NC1">QS082021 NC1</option>
                                    <option value="QS012022 NC2">QS012022 NC2</option>
                                    <option value="QS012022 NC3">QS012022 NC3</option>
                                    <option value="ARC082021 NC1">ARC082021 NC1</option>
                                    <option value="ARC012022 NC2">ARC012022 NC2</option>
                                    <option value="ARC012022 NC3">ARC012022 NC3</option>
                                    <option value="VAL012022 NC1">VAL012022 NC1</option>
                                    <option value="VAL012022 NC2">VAL012022 NC2</option>
                                    <option value="IRR012022 NC1">IRR012022 NC1</option>
                                    <option value="SG012022 NC1">SG012022 NC1</option>
                                    <option value="SG012022 NC2">SG012022 NC2</option>
                                    <option value="UB012022 NC1">UB012022 NC1</option>
                                    <option value="UB012022 NC2">UB012022 NC2</option>
                                    <option value="IT012022 NC1">IT012022 NC1</option>
                                    <option value="IT012022 NC2">IT012022 NC2</option>
                                    <option value="PS012022 NC1">PS012022 NC1</option>
                                    <option value="PS012022 NC2">PS012022 NC2</option>
                                    <option value="TM012022 NC1">TM012022 NC1</option>
                                    <option value="TM012022 NC2">TM012022 NC2</option>
                                    <option value="RM012022 NC1">RM012022 NC1</option>
                                    <option value="RM012022 NC2">RM012022 NC2</option>
                                    <option value="SS012022 NC1">SS012022 NC1</option>
                                    <option value="SS012022 NC2">SS012022 NC2</option>
                                    <option value="MM012022 NC1">MM012022 NC1</option>
                                    <option value="MM012022 NC2">MM012022 NC2</option>
                                    <option value="HR012022 NC1">HR012022 NC1</option>
                                    <option value="HR012022 NC2">HR012022 NC2</option>
                                    <option value="ACC012022 NC1">ACC012022 NC1</option>
                                    <option value="ACC012022 NC2">ACC012022 NC2</option>
                            </select>
                            <label>Select Class: </label>
                        </div>
                       
                        <div className="col s12 m4 l4">
                            <div className="input-field">
                                <input id="moduleName" type="text" onChange={(e) => setModuleName(e.target.value)} value={moduleName} required />
                                <label htmlFor="moduleName" className="active">Module Name:</label>
                            </div>
                        </div>
                        <div className="col s12 m4 l4">
                            <div className="input-field">
                                <input id="gClassLink" type="text" onChange={(e) => setClassLink(e.target.value)} value={classLink} required />
                                <label htmlFor="gClassLink" className="active">Google Classroom Link:</label>
                            </div>
                        </div>
                        <div className="col s12 m4 l4">
                            <div className="input-field">
                                <input id="gClassCode" type="text" onChange={(e) => setClassCode(e.target.value)} value={classCode} required />
                                <label htmlFor="gClassCode" className="active">Google Classroom Code:</label>
                            </div>
                        </div>
                        {
                            error && <p className="main-color-text tiny-text mt-5">Please provide all the required fields.</p>
                        }
                        <div className="control">
                            <button className="button is-success mt-3" id="Btn">
                                <span className="icon">
                                <IoIosAddCircle size="1.25rem" color="white"/>
                                </span>
                                <span className="white-text">Add Classroom</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </TeacherLayout>
     );
}
 
const mapStateToProps = (state) => {
    //console.log(state)
    return {
        addClassSuccess: state.addClass.addClassSuccess,
        addClassError: state.addClass.addClassError,
        admins: state.firestore.ordered.admins,
        auth: state.firebase.auth
    }
    
}
 

const mapDispatchToProps = (dispatch) => {
    return {
        addClassAction: (onlineClass) => dispatch(addClassAction(onlineClass)),
        resetSuccess: () => dispatch({ type: "ADD_CLASS", success: false })
    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "admins", 
            },
    ])
)(AddClass);